import { render, staticRenderFns } from "./request-money.vue?vue&type=template&id=1553cc62&scoped=true&"
import script from "./request-money.vue?vue&type=script&lang=js&"
export * from "./request-money.vue?vue&type=script&lang=js&"
import style1 from "./request-money.vue?vue&type=style&index=1&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1553cc62",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/pjabang/projects/taybull-ui/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VAlert,VBtn,VFlex,VLayout,VTextField})
